import Swal from 'sweetalert2'
import { HTTP } from './axiosConfig'
import { firestoreDB } from './firebase.js'
const firebase = require("firebase");

let deletedProducts = []
let productsToDelete = []

const deleteProductAction = {
    methods: {
        triggerDeleteAction (productId, name, refresh) {
            let my = this
            Swal.queue([{
                title: `<h5><< ${name} >> <br><small>${my.labels['delete_product_warning']}</small></h5>`,
                showCancelButton: true,
                confirmButtonText: my.labels['proceed'],
                showLoaderOnConfirm: true,
                preConfirm: () => {
                    return new Promise((resolve) => {
                        my.deleteProduct(productId, refresh)
                    })
                }}])
        },
        deleteProduct (productId, refresh) {
            var my = this
            HTTP.delete(`/api/products/${productId}`)
                .then(() => {
                    // HACK for time it takes for algolia to update index
                    // Delay to return to product page
                    if (!refresh) {
                        setTimeout(function () {
                            my.$router.push({ name: 'ProductList' })
                        }, 1500)
                    }
                    // Delay to fire success
                    setTimeout(function () {
                        $('#' + productId).parent('li').remove()
                        Swal.fire(
                            '',
                            my.labels.product_deleted,
                            'success'
                        )
                        my.search.refresh()
                    }, 3000)

                    // Delay to remove thumbnail & refresh search success
                    setTimeout(function () {
                        $('#thumb_' + productId).parent('li').remove()
                        my.search ? my.search.refresh() : null
                    }, 5000)

                    this.deleteProductLeaderFirestore(productId)
                })
                .catch((err) => {
                    Swal.fire(
                        '',
                        my.labels.delete_product_error,
                        'error'
                    )
                })
        },
        bulkDelete () {
            productsToDelete.forEach((productId) => {
                HTTP.delete(`/api/products/${productId}`)
                    .then(() => {
                        deletedProducts.push(productId)
                    })
                    .catch((err) => console.log('err', productId))
            })
        },
        deleteProductLeaderFirestore (productId) {
            // Update firestore
            firestoreDB.collection(process.env.ENV_SHORTNAME + '_productLeaders').doc(productId)
                .delete()
                .then(function () {
                    console.log("Document successfully deleted!");
                })
                .catch(function(error) {
                    console.error("Error removing document: ", error);
                });
        }
    }
}

export default deleteProductAction



// WEBPACK FOOTER //
// ./src/assets/js/deleteProductMixin.js